<template>
  <div class="mobile-width">
    <apexchart
      ref="apexChartExtra"
      :options="chartData.chartOptions"
      :series="chartData.chartSeries"
      :width="chartData.width"
      :height="chartData.height"
      :key="chartKey"
    ></apexchart>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts';

export default {
  data() {
    return {
      chartKey: 0,
    };
  },
  components: {
    apexchart: VueApexCharts,
  },

  watch: {
    chartData: {
      handler() {
        this.chartKey += 1;
      },
      deep: true,
    },
  },
  props: {
    chartData: {
      required: true,
    },
  },
  methods: {
    async getChartImageBase64() {
      if (this.$refs.apexChartExtra && this.$refs.apexChartExtra.chart) {
        const res = await this.$refs.apexChartExtra.chart.dataURI();
        return res.imgURI;
      } else {
        console.error('A instância do ApexCharts não está disponível.');
        return null;
      }
    },
  },
};
</script>

<style scoped>
/* @media only screen and (min-device-width: 300px) and (max-device-width: 480px) and (-webkit-min-device-pixel-ratio: 2) {
  .mobile-width {
    width: 500px;
  }
} */
</style>
